export enum VirtualPlatform {
    Zoom = 0,
    MicrosoftTeams = 1,
    GoogleMeet = 2,
    WebEx = 3,
    Custom = 99
}
